// extracted by mini-css-extract-plugin
export var deleteIcon = "_q0-5";
export var deleteOption = "_q0-3";
export var divider = "_q0-2";
export var downloadIcon = "_q0-4";
export var drawer = "_q0-0";
export var drawerFooter = "_q0-6";
export var drawerOpen = "_q0-1";
export var highlighted = "_q0-7";
export var lighterHighlight = "_q0-8";